import axios from '../axios/axios';
import {
  POC_DATA_REQUEST,
  POC_DATA_SUCCESS,
  POC_DATA_FAIL,
} from '../constants/pusposeOfCoverageConstants';

export const purposeOfCoverageAction = () => async (dispatch) => {
  try {
    dispatch({ type: POC_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s1',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: POC_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }

    dispatch({
      type: POC_DATA_FAIL,
      payload: error,
    });
  }
};
